export default __webpack_public_path__ + "static/media/94.cd58b93e.jpg";